var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",on:{"click":function($event){return _vm.route($event)},"mouseup":function($event){if('button' in $event && $event.button !== 1){ return null; }return _vm.route($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }